<script setup>
import YearMonthPicker from '@/components/Leave/YearMonthPicker.vue';
import LeaveTable from '@/components/Leave/LeaveTable.vue';
import LeaveDetail from '@/components/Leave/LeaveDetail.vue';
import {onMounted, ref} from "vue"
import {useToast} from "vue-toastification"

const toast = useToast()

const leave_type = ref('all')
const year = ref(dayjs().year())
const month = ref(dayjs().month() + 1)
const leave = ref({})
const leaves = ref([])
const showModal = ref(false)
const iconMap = ref(window.icon_map)
const wordingMap = ref(window.wording_map)

async function getLeave(id) {
    const response = await axios.get(`/api/leaves/${id}`)
    showModal.value = true
    leave.value = response.data.data
}

async function getLeaves() {
    const response = await axios.get('/api/leaves', {
        params: {
            year: year.value,
            month: month.value,
            leave_type: leave_type.value
        }
    });
    leaves.value = response.data.data
}

async function deleteLeave(id) {
    try {
        await axios.delete(`/api/leaves/${id}`)
        toast.success('remove leave success')
        showModal.value = false
        await getLeaves()
    } catch (e) {
        toast.error(e.response.data.message)
    }
}

async function cancelLeave(id, remark) {
    try {
        await axios.patch(`/api/leaves/${id}/cancel`, {remark})
        toast.success('apply cancel leave success')
        showModal.value = false
        await getLeaves()
    } catch (e) {
        toast.error(e.response.data.message)
    }
}

async function changeMonth(value) {
    month.value = +value
    await getLeaves()
}

async function changeLeaveType(value) {
    leave_type.value = value
    await getLeaves()
}

async function closeModal() {
    showModal.value = false
    setTimeout(() => {
        getLeaves()
    }, 500)
}

async function changeYear(operator) {
    if (operator === '+') {
        year.value++
    } else if (operator === '-') {
        year.value--
    }
    await getLeaves()
}


onMounted(() => {
    getLeaves()
})

</script>

<template>
    <div class="w-full flex-col">
        <header class="flex w-full justify-between">
            <div>
                <a href="/user/leaves/create" class="bg-gray-600 flex items-center text-white px-2 py-1 rounded">Apply
                </a>
            </div>
        </header>
        <div class="mt-4">
            <YearMonthPicker
                :year="year"
                :month="month"
                @setYear="changeYear"
                @setMonth="changeMonth"
                @setLeaveType="changeLeaveType"
            />
        </div>
        <hr class="my-4">
        <div>
            <LeaveTable
                :leaves="leaves"
                :leave_type="leave_type"
                @show="getLeave"
                :iconMap="iconMap"
            />
        </div>
    </div>
    <vue-final-modal
        classes="flex justify-center items-center"
        v-model="showModal"
        @submit="closeModal"
    >
        <LeaveDetail
            :leave="leave"
            @delete="deleteLeave"
            @cancel="cancelLeave"
            :iconMap="iconMap"
            :wordingMap="wordingMap"
        />

    </vue-final-modal>
</template>
